import { render } from "./EtatPaiement.vue?vue&type=template&id=880bf6e4&ts=true"
import script from "./EtatPaiement.vue?vue&type=script&lang=ts"
export * from "./EtatPaiement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__